import { api } from "./client";

const PK = "/games/nfl-pickem";

// ── Pools ────────────────────────────────────────────────────────────────
export async function getMyPickemPools(seasonId) {
  const resp = await api.get(`${PK}/seasons/${seasonId}/pools/mine`);
  return Array.isArray(resp.data) ? resp.data : [];
}

export async function getAllPickemPools(seasonId) {
  const resp = await api.get(`${PK}/seasons/${seasonId}/pools/`);
  return Array.isArray(resp.data) ? resp.data : [];
}

export async function getPickemPool(seasonId, poolId) {
  const resp = await api.get(`${PK}/seasons/${seasonId}/pools/${poolId}`);
  return resp.data;
}

export async function createPickemPool(seasonId, body) {
  const resp = await api.post(`${PK}/seasons/${seasonId}/pools/`, body);
  return resp.data;
}

export async function updatePickemPool(seasonId, poolId, body) {
  const resp = await api.patch(`${PK}/seasons/${seasonId}/pools/${poolId}`, body);
  return resp.data;
}

export async function joinPickemPool(seasonId, poolId) {
  const resp = await api.post(`${PK}/seasons/${seasonId}/pools/${poolId}/join`);
  return resp.data;
}

// ── Picks ────────────────────────────────────────────────────────────────
export async function getPickemWeek(seasonId, poolId, week) {
  const resp = await api.get(`${PK}/seasons/${seasonId}/pools/${poolId}/picks/week/${week}`);
  return resp.data;
}

export async function savePickemPick(seasonId, poolId, week, body) {
  const resp = await api.put(`${PK}/seasons/${seasonId}/pools/${poolId}/picks/week/${week}`, body);
  return resp.data;
}

export async function getMyPickemPicks(seasonId, poolId) {
  const resp = await api.get(`${PK}/seasons/${seasonId}/pools/${poolId}/picks/mine`);
  return resp.data;
}

// ── Payouts, members, invites ────────────────────────────────────────────
export async function getPickemPayouts(seasonId, poolId) {
  const resp = await api.get(`${PK}/seasons/${seasonId}/pools/${poolId}/payouts`);
  return Array.isArray(resp.data) ? resp.data : [];
}

export async function savePickemPayouts(seasonId, poolId, payouts) {
  const resp = await api.put(`${PK}/seasons/${seasonId}/pools/${poolId}/payouts`, payouts);
  return Array.isArray(resp.data) ? resp.data : [];
}

export async function updatePickemMember(seasonId, poolId, userId, body) {
  const resp = await api.patch(
    `${PK}/seasons/${seasonId}/pools/${poolId}/members/${userId}`, body
  );
  return resp.data;
}

export async function removePickemMember(seasonId, poolId, userId) {
  const resp = await api.delete(`${PK}/seasons/${seasonId}/pools/${poolId}/members/${userId}`);
  return resp.data;
}

export async function sendPickemInvites(seasonId, poolId, emails, message, subject, mode) {
  // A mailshot to a full pool takes longer than the 10s default allows.
  const resp = await api.post(`${PK}/seasons/${seasonId}/pools/${poolId}/invite`, {
    emails, message, subject, mode,
  }, { timeout: 120000 });
  return resp.data;
}

// ── Leaderboards and divisions ───────────────────────────────────────────
export async function getPickemLeaderboard(seasonId, poolId) {
  const resp = await api.get(`${PK}/seasons/${seasonId}/pools/${poolId}/leaderboard`);
  return resp.data;
}

/** Every player's pick for every week — the All Picks grid. */
export async function getPickemAllPicks(seasonId, poolId) {
  const resp = await api.get(`${PK}/seasons/${seasonId}/pools/${poolId}/all-picks`);
  return resp.data;
}

export async function getPickemWeekResults(seasonId, poolId, week) {
  const resp = await api.get(`${PK}/seasons/${seasonId}/pools/${poolId}/week/${week}/results`);
  return resp.data;
}

export async function getPickemDivisions(seasonId, poolId) {
  const resp = await api.get(`${PK}/seasons/${seasonId}/pools/${poolId}/divisions/`);
  return resp.data;
}

export async function savePickemDivision(seasonId, poolId, body) {
  const resp = await api.put(`${PK}/seasons/${seasonId}/pools/${poolId}/divisions/`, body);
  return resp.data;
}

export async function getPickemDivisionLeaderboard(seasonId, poolId) {
  const resp = await api.get(`${PK}/seasons/${seasonId}/pools/${poolId}/divisions/leaderboard`);
  return resp.data;
}

// ── Smack board (arg order matches the shared SmackBoard component) ──────
export async function getPkSmackMessages(poolId, seasonId) {
  const resp = await api.get(`${PK}/seasons/${seasonId}/pools/${poolId}/smack/`);
  return resp.data;
}

export async function postPkSmackMessage(poolId, body, seasonId) {
  const resp = await api.post(`${PK}/seasons/${seasonId}/pools/${poolId}/smack/`, { body });
  return resp.data;
}

export async function getPkSmackReplies(poolId, messageId, seasonId) {
  const resp = await api.get(`${PK}/seasons/${seasonId}/pools/${poolId}/smack/${messageId}/replies`);
  return resp.data;
}

export async function postPkSmackReply(poolId, messageId, body, seasonId) {
  const resp = await api.post(`${PK}/seasons/${seasonId}/pools/${poolId}/smack/${messageId}/replies`, { body });
  return resp.data;
}

export async function reactPkSmack(poolId, messageId, reaction, seasonId) {
  const resp = await api.post(`${PK}/seasons/${seasonId}/pools/${poolId}/smack/${messageId}/react`, { reaction });
  return resp.data;
}

export async function deletePkSmackMessage(poolId, messageId, seasonId) {
  const resp = await api.delete(`${PK}/seasons/${seasonId}/pools/${poolId}/smack/${messageId}`);
  return resp.data;
}


export async function sendPickemRecapTest(seasonId, poolId, week) {
  const resp = await api.post(
    `${PK}/seasons/${seasonId}/pools/${poolId}/recap-test`,
    null,
    { params: week ? { week } : {} }
  );
  return resp.data;
}
